import { render, staticRenderFns } from "./textimgProperty.vue?vue&type=template&id=6c369c50"
import script from "./textimgProperty.vue?vue&type=script&lang=js"
export * from "./textimgProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports